import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Header from '../../Header/Header';
import { history } from '../../helpers/history';
import { Helmet } from 'react-helmet';
import HomeSlidTabs from '../Home/HomeSlidTabs';

class PromotionRules extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { t } = this.props;
        const { i18n } = this.props;
        return (
            <>
                {
                    process.env.REACT_APP_MODE != "development" && <Helmet>
                        <title>Gulf Ticket : PromotionRules</title>
                        <meta name="description" content="Gulf Ticket PromotionRules" />
                    </Helmet>
                }
                <Header />
                <div class="container">
                    <HomeSlidTabs />
                    <div class="rht bg2 content">
                        <div class="bredCrums">
                            <ul>
                                <li><a onClick={() => { history.push('/') }}>Home <img src="./assets/img/icons/right-angle.png" /></a></li>
                                <li><a class="active">Promotions</a></li>
                            </ul>
                        </div>
                        <div class="myAccount">
                            <div class="promotions">
                                <div class="promotionsHead">
                                    <div class="promotionsHeadLft">
                                        <h2>Launch Extravaganza</h2>
                                        <p>Offer lasts only 3 Weeks after launch.</p>
                                        <p>Terms & Conditions</p>
                                    </div>
                                    <div class="promotionsHeadRht">
                                        <a onClick={() => { history.goBack() }}>{t('lblBack')}</a>
                                    </div>
                                </div>
                                <div class="promoCont">
                                    <div class="participate">
                                        <h3>How to Participate:</h3>
                                        <p>It's simple! Just follow these steps:</p>
                                        <ul>
                                            <li>Register on the Gulf Ticket website. It's free and quick!</li>
                                            <li>All registered users are automatically entered into the launch offer draw.</li>
                                            <li>Sit back, relax, and dream big! Winners will be announced during Live Show at 8:00 PM UAE time.</li>
                                        </ul>
                                    </div>
                                    <div class="participate">
                                        <h3>Claiming Your Prize:</h3>
                                        <ul>
                                            <li>Winners will be notified via email and phone number provided during registration.</li>
                                            <li>Winning amount will be credited to your Gulf Ticket wallet. This can be withdrawn at any time.</li>
                                            <li>Claim your prize within 10 days from the notification date.</li>
                                        </ul>
                                    </div>
                                    <div class="participate">
                                        <h3>Additional Information:</h3>
                                        <ul>
                                            <li>For full terms and conditions, please visit the dedicated page.</li>
                                            <li>Play responsibly and within financial limits.</li>
                                            <li>Visit our website for more information on responsible gaming practices.</li>
                                            <li>For any questions, contact our friendly customer support team</li>
                                        </ul>
                                    </div>
                                    <div class="participateBtn">
                                        <a onClick={() => { history.push('/register') }}>Register Now</a>
                                    </div>
                                    <div class="participate">
                                        <p >For offer terms and conditions, <a onClick={() => { history.push('/promotionterms') }}>Click here.</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="wrap2 contentalign">
                        <button type="button" className="backBtn" onClick={() => { history.goBack() }}>
                            <img src="./assets/img/icons/Back-Icon.svg" alt='Back-Icon' />
                            <span>{t('lblBack')}</span>
                        </button>
                        <div className="addlPage">
                            <div className="text-center text-brand text-2xl md:text-3xl font-bold tracking-wide">LAUNCH EXTRAVAGANZA</div>
                            <div className="text-xl text-center text-smallCaps font-bold">Offer lasts only 3 Weeks after launch.</div>
                            <div className="text-center font-semibold">Terms & Conditions</div>
                            <div className="flex gap-5 flex-col items-start mt-4">
                                <div>
                                    <h4 className="text-lg font-bold">How to Participate:</h4>
                                    <p>It's simple! Just follow these steps:</p>
                                    <ul className="list-disc pl-5 lg:pl-7 rtl:pr-5 lg:rtl:pr-7">
                                        <li>Register on the Gulf Ticket website. It's free and quick!</li>
                                        <li>All registered users are automatically entered into the launch offer draw.</li>
                                        <li>
                                            Sit back, relax, and dream big! Winners will be announced during Live Show at 8:00 PM UAE
                                            time.
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <h4 className="text-lg font-bold">Claiming Your Prize:</h4>
                                    <ul className="list-disc pl-5 lg:pl-7 rtl:pr-5 lg:rtl:pr-7">
                                        <li>
                                            Winners will be notified via email and phone number provided during registration.
                                        </li>

                                        <li>
                                            Winning amount will be credited to your Gulf Ticket wallet. This can be withdrawn
                                            at any time.
                                        </li>
                                        <li>Claim your prize within 10 days from the notification date.</li>
                                    </ul>
                                </div>

                                <div>
                                    <h4 className="text-lg font-bold">Additional Information:</h4>
                                    <ul className="list-disc pl-5 lg:pl-7 rtl:pr-5 lg:rtl:pr-7">
                                        <li>For full terms and conditions, please visit the dedicated page.</li>

                                        <li>Play responsibly and within financial limits.</li>
                                        <li>Visit our website for more information on responsible gaming practices.</li>
                                        <li>For any questions, contact our friendly customer support team.</li>
                                    </ul>
                                </div>

                                <button className="bg-brand text-white rounded-3xl font-bold px-4 py-1 mx-auto">
                                    <a onClick={() => { history.push('/register') }}>Register Now</a>
                                </button>
                                <p className="text-center w-full -mt-3">
                                    For offer terms and conditions, click &nbsp;
                                    <a onClick={() => { history.push('/promotionterms') }} className="underline text-blue-700">here</a>.
                                </p>
                            </div>
                        </div>
                    </div> */}
                </div>
            </>
        )
    }

}

export default withTranslation()(PromotionRules)